import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TextMaskModule } from 'angular2-text-mask';
import { UiCopyButtonModule } from '@unico-people/shared/dashboard/ui-copy-button';

import { InfosContatoColabReadComponent } from './read/infos-contato-colab.component';
import { InfosContatoColabUpdateComponent } from './update/infos-contato-colab.component';

@NgModule({
  exports: [InfosContatoColabReadComponent, InfosContatoColabUpdateComponent],
  declarations: [InfosContatoColabReadComponent, InfosContatoColabUpdateComponent],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, TextMaskModule, UiCopyButtonModule]
})
export class InfosContatoColabModule {}
